import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon, MailIcon, MapPinIcon, MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { company, navLinks } from '../../data/company';
export function Header() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return <header className="sticky top-0 z-40 bg-ink" data-id="element-124" data-mp="hz7tt2m0v2w3">
      <div className="hidden bg-flame text-ink xl:block" data-id="element-125" data-mp="i0srv27jp3yp">
        <div className="mx-auto flex h-10 max-w-[1320px] items-center justify-between gap-6 px-5 text-sm font-semibold md:px-8" data-id="element-126" data-mp="vr5yn18pacmg">
          <span className="inline-flex items-center gap-2 whitespace-nowrap" data-id="element-127" data-mp="qz4fcvd47lmx">
            <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-128" data-mp="39jv89586ic2" />
            {company.address}
          </span>
          <div className="flex items-center gap-6" data-id="element-129" data-mp="3uflbcw41s24k">
            <a href={company.phoneHref} className="inline-flex items-center gap-2 whitespace-nowrap hover:underline" data-id="element-130" data-mp="3ues8i687lwrp">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-131" data-mp="buhzfjyrqk2e" />
              {company.phone}
            </a>
            <a href={company.emailHref} className="inline-flex items-center gap-2 whitespace-nowrap hover:underline" data-id="element-132" data-mp="gl8753uo2z09">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-133" data-mp="lj9pfmk9quao" />
              {company.email}
            </a>
          </div>
        </div>
      </div>

      <div className="relative border-b border-edge" data-id="element-134" data-mp="3p1a1bcsy3jtk">
        <div className="mx-auto flex h-20 max-w-[1320px] items-stretch justify-between gap-6 pl-5 md:pl-8" data-id="element-135" data-mp="3p2311tthl927">
          <Link to="/" aria-label="Universal Packaging Industries, home" className="flex shrink-0 items-center" data-id="element-136" data-mp="3tythii97e6o5">
            <img src={company.logoOrange} alt="Universal Packaging Industries LLC" className="h-8 w-auto sm:h-9 md:h-11" data-id="element-137" data-mp="1uhejtl93vw3" />
          </Link>

          <nav aria-label="Main" className="hidden xl:flex" data-id="element-138" data-mp="1db7ptr4j7dwk">
            <ul className="flex items-stretch" data-id="element-139" data-mp="1ddtwzpnifre9">
              {navLinks.map(link => <li key={link.to} className="flex" data-id="element-140" data-mp="3aak4bwpthdo8">
                  <NavLink to={link.to} end={link.to === '/'} className={({
                isActive
              }) => `flex items-center whitespace-nowrap border-b-[3px] px-5 pt-[3px] text-sm font-bold uppercase tracking-[0.08em] transition-colors duration-150 ${isActive ? 'border-flame text-flame' : 'border-transparent text-chalk/80 hover:text-chalk'}`} data-id="element-141" data-mp="35e3emy2yyr91">
                    {link.label}
                  </NavLink>
                </li>)}
            </ul>
          </nav>

          <div className="flex items-stretch" data-id="element-142" data-mp="2vlxoltwa2jwh">
            <Link to="/contact" className="hidden items-center gap-2 whitespace-nowrap bg-flame px-8 text-sm font-bold uppercase tracking-[0.08em] text-ink transition-colors duration-150 hover:bg-chalk sm:inline-flex" data-id="element-143" data-mp="27xms12xm76e0">
              Request a Quote
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-144" data-mp="n7hf6rh155k5" />
            </Link>
            <button type="button" onClick={() => setOpen(value => !value)} className="inline-flex w-20 items-center justify-center border-l border-edge text-chalk xl:hidden" aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-145" data-mp="n9c1oa7y95qc">
              {open ? <XIcon className="h-6 w-6" data-id="element-146" data-mp="165k7bf4vjim6" /> : <MenuIcon className="h-6 w-6" data-id="element-147" data-mp="s6kjg9p6r7r2" />}
            </button>
          </div>
        </div>

        <AnimatePresence data-id="element-148" data-mp="x5osn0c415he">
          {open && <motion.nav id="mobile-menu" aria-label="Mobile" initial={{
          opacity: 0,
          y: -8
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -8
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} className="absolute inset-x-0 top-full border-b border-edge bg-ink xl:hidden" data-id="element-149" data-mp="x4dnaw30npo6">
              <ul className="mx-auto max-w-[1320px] px-5 py-4 md:px-8" data-id="element-150" data-mp="3se18dz9dezvp">
                {navLinks.map(link => <li key={link.to} data-id="element-151" data-mp="3odh84mti3g5c">
                    <NavLink to={link.to} end={link.to === '/'} className={({
                isActive
              }) => `block border-b border-edge py-4 font-display text-3xl font-bold uppercase ${isActive ? 'text-flame' : 'text-chalk'}`} data-id="element-152" data-mp="3jeeedyiz0wco">
                      {link.label}
                    </NavLink>
                  </li>)}
                <li className="pt-5" data-id="element-153" data-mp="2voa97mq4wojk">
                  <Link to="/contact" className="flex items-center justify-center gap-2 bg-flame py-4 font-bold uppercase text-ink" data-id="element-154" data-mp="2vpd5692bdh6c">
                    Request a Quote
                    <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-155" data-mp="2gjfqrqttopp4" />
                  </Link>
                </li>
              </ul>
            </motion.nav>}
        </AnimatePresence>
      </div>
    </header>;
}